<template>
  <div class="is-fullwidth box" id="containerTableAps">
    <h2 class="is-size-4" align="left"><b>Top Vagalumes Acessados</b></h2>
    <table margin="4" class="table is-fullwidth">
      <thead>
        <tr id="titleTable">
          <td align="left">
            <b>Nome</b>
          </td>
          <td align="left"><b>Acessos</b></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(average, i) in averages" :key="i" id="linesTableAps">
          <td align="left">{{ name[i] }}</td>
          <td algin="left">{{ average }}</td>
        </tr>
      </tbody>
      <tfoot>
        <td colspan="5" align="center">
          <router-link :to="{ path: '/radios' }">Mostrar mais</router-link>
        </td>
      </tfoot>
    </table>
  </div>
</template>

<script>
export default {
  name: "CustomTableAps",
  props: {
    aps: Object
  },
  data() {
    return {
      averages: [],
      name: []
    };
  },
  beforeUpdate() {
    this.averages = this.aps.avarage;
    this.name = this.aps.name;
  },
  watch: {
    aps() {
      this.$forceUpdate();
    }
  }
};
</script>

<style>
#noneContentTable {
  height: 400px;
  display: flex;
  justify-content: center;
  align-items: center;
}
#titleTable td {
  color: gray;
  font-size: 1rem;
}
#containerTableAps {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/CustomTableAps.vue